import { render, staticRenderFns } from "./ProjectMarking.vue?vue&type=template&id=6ca4ffb8&scoped=true"
import script from "./ProjectMarking.vue?vue&type=script&lang=js"
export * from "./ProjectMarking.vue?vue&type=script&lang=js"
import style0 from "./ProjectMarking.vue?vue&type=style&index=0&id=6ca4ffb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4ffb8",
  null
  
)

export default component.exports